export { Input } from './Input';
export type {
  InputEvent,
  InputChildrenAttrs,
  Props as InputProps,
} from './Input';
